import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";

// Rendu principal
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// ✅ Enregistrement du Service Worker pour activer le mode PWA
registerServiceWorker();
